import {
  ADD_CREDIT_LIMIT_ALLOCATION,
  ADD_CREDIT_LIMITS,
  ADD_PARTNERS,
  BUYER,
  REGISTER_FOR_FINANCING,
  SUPPLIER,
} from "codes";

export const getPresalesRouteForStep = (
  companyType: string | null | undefined,
  step: number,
): string => {
  const isBuyer =
    (companyType ?? "").toLowerCase() === BUYER.toLowerCase() ||
    (companyType ?? "").toLowerCase() === "buyer";
  const isSupplier =
    (companyType ?? "").toLowerCase() === SUPPLIER.toLowerCase() ||
    (companyType ?? "").toLowerCase() === "seller" ||
    (companyType ?? "").toLowerCase() === "supplier";

  if (isBuyer) {
    if (step <= 0) {
      return REGISTER_FOR_FINANCING;
    }
    if (step === 1) {
      return ADD_CREDIT_LIMITS;
    }
    if (step === 2) {
      return ADD_PARTNERS;
    }
    return ADD_CREDIT_LIMIT_ALLOCATION;
  }

  if (isSupplier) {
    if (step <= 0) {
      return REGISTER_FOR_FINANCING;
    }
    if (step === 1) {
      return ADD_PARTNERS;
    }
    return ADD_CREDIT_LIMITS;
  }

  return REGISTER_FOR_FINANCING;
};

const getPresalesRouteOrder = (path: string, isSeller: boolean): number => {
  const supplierRoutes = [
    REGISTER_FOR_FINANCING,
    ADD_PARTNERS,
    ADD_CREDIT_LIMITS,
  ];
  const buyerRoutes = [
    REGISTER_FOR_FINANCING,
    ADD_CREDIT_LIMITS,
    ADD_PARTNERS,
    ADD_CREDIT_LIMIT_ALLOCATION,
  ];
  const routes = isSeller ? supplierRoutes : buyerRoutes;
  return routes.indexOf(path);
};

type ReplacePresalesRouteInput = {
  currentPath: string;
  targetPath?: string;
  isSeller: boolean;
  hasProfile: boolean;
  activeStep: number;
};

export const shouldReplacePresalesRoute = ({
  currentPath,
  targetPath,
  isSeller,
  hasProfile,
  activeStep,
}: ReplacePresalesRouteInput): boolean => {
  if (!targetPath || currentPath === targetPath) {
    return false;
  }

  if (
    hasProfile &&
    activeStep > 0 &&
    currentPath === REGISTER_FOR_FINANCING
  ) {
    return true;
  }

  const currentOrder = getPresalesRouteOrder(currentPath, isSeller);
  const targetOrder = getPresalesRouteOrder(targetPath, isSeller);
  if (currentOrder >= 0 && targetOrder >= 0) {
    return false;
  }

  return currentPath !== targetPath;
};
